<template>
  <!-- NOTE (TEMPLATE) to build a general review and use it in the project as a component -->

  <div class="animated fadeIn">
    <table class="table table-striped">
      <tbody>
        <tr
          :class="
            score[0] == 4
              ? 'bg-success'
              : score[0] == 3
              ? 'table-success'
              : score[0] == 2
              ? 'table-warning'
              : score[0] == 1
              ? 'table-danger'
              : score[0] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>بیان مساله</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[0]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[1] == 4
              ? 'bg-success'
              : score[1] == 3
              ? 'table-success'
              : score[1] == 2
              ? 'table-warning'
              : score[1] == 1
              ? 'table-danger'
              : score[1] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>ضرورت طرح</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[1]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[2] == 4
              ? 'bg-success'
              : score[2] == 3
              ? 'table-success'
              : score[2] == 2
              ? 'table-warning'
              : score[2] == 1
              ? 'table-danger'
              : score[2] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>همراستایی با اولویتهای تقسیم کار ملی ستاد</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[2]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[3] == 4
              ? 'bg-success'
              : score[3] == 3
              ? 'table-success'
              : score[3] == 2
              ? 'table-warning'
              : score[3] == 1
              ? 'table-danger'
              : score[3] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>روش انجام طرح</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[3]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[4] == 4
              ? 'bg-success'
              : score[4] == 3
              ? 'table-success'
              : score[4] == 2
              ? 'table-warning'
              : score[4] == 1
              ? 'table-danger'
              : score[4] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>زمان‌بندی انجام طرح</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[4]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[5] == 4
              ? 'bg-success'
              : score[5] == 3
              ? 'table-success'
              : score[5] == 2
              ? 'table-warning'
              : score[5] == 1
              ? 'table-danger'
              : score[5] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>هزینه انجام طرح</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[5]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[6] == 4
              ? 'bg-success'
              : score[6] == 3
              ? 'table-success'
              : score[6] == 2
              ? 'table-warning'
              : score[6] == 1
              ? 'table-danger'
              : score[6] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>کیفیت طرح</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[6]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[7] == 4
              ? 'bg-success'
              : score[7] == 3
              ? 'table-success'
              : score[7] == 2
              ? 'table-warning'
              : score[7] == 1
              ? 'table-danger'
              : score[7] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>متناسب بودن کیفیت انجام طرح و مبلغ پیشنهادی</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[7]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[8] == 4
              ? 'bg-success'
              : score[8] == 3
              ? 'table-success'
              : score[8] == 2
              ? 'table-warning'
              : score[8] == 1
              ? 'table-danger'
              : score[8] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>توانایی علمی مجری و همکاران در اجرای طرح</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[8]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[9] == 4
              ? 'bg-success'
              : score[9] == 3
              ? 'table-success'
              : score[9] == 2
              ? 'table-warning'
              : score[9] == 1
              ? 'table-danger'
              : score[9] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>دستاوردهای طرح</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[9]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[10] == 4
              ? 'bg-success'
              : score[10] == 3
              ? 'table-success'
              : score[10] == 2
              ? 'table-warning'
              : score[10] == 1
              ? 'table-danger'
              : score[10] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>تکراری بودن طرح یا وجود طرح‌های مشابه</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[10]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[11] == 4
              ? 'bg-success'
              : score[11] == 3
              ? 'table-success'
              : score[11] == 2
              ? 'table-warning'
              : score[11] == 1
              ? 'table-danger'
              : score[11] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>میزان نوآوری طرح</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[11]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[12] == 4
              ? 'bg-success'
              : score[12] == 3
              ? 'table-success'
              : score[12] == 2
              ? 'table-warning'
              : score[12] == 1
              ? 'table-danger'
              : score[12] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>دسترسی مجری به امکانات مورد نیاز برای اجرای طرح</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[12]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[13] == 4
              ? 'bg-success'
              : score[13] == 3
              ? 'table-success'
              : score[13] == 2
              ? 'table-warning'
              : score[13] == 1
              ? 'table-danger'
              : score[13] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>کاربردی بودن طرح و قابلیت آن در حل مشکلات صنعت</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[13]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[14] == 4
              ? 'bg-success'
              : score[14] == 3
              ? 'table-success'
              : score[14] == 2
              ? 'table-warning'
              : score[14] == 1
              ? 'table-danger'
              : score[14] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>سطح آمادگی فناوری طرح (TRL)</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[14]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr>
          <td>نقاط قوت و ضعف طرح از دید داور</td>
          <td>
            <b-form-textarea
              trim
              :disabled="disabled"
              v-model="refereeIdea2"
            ></b-form-textarea>
          </td>
        </tr>
        <tr>
          <td>نمره کل طرح از 100</td>
          <td>{{ totalScore }}</td>
        </tr>
        <tr>
          <td>نظر نهایی داور</td>
          <td>
            <b-form-select
              :disabled="disabled"
              :options="refereeDecisions"
              v-model="refereeDecision2"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="!disabled">
      <p
        variant="danger"
        v-if="
          !(
            refereeDecision2 &&
            score.filter((x) => x).length == 15 &&
            refereeIdea2
          )
        "
      >
        لطفا به منظور ثبت داوری به تمامی سوالات چند گزینه‌ای پاسخ دهید و نظر
        نهایی خود را نیز انتخاب کنید.
      </p>
      <p></p>
      <div class="d-flex justify-content-center">
        <!-- NOTE (b-sendReview) to send review -->
        <b-button
          variant="success"
          class="mx-2"
          :disabled="
            !(
              refereeDecision2 &&
              score.filter((x) => String(x)).length == 15 &&
              refereeIdea2
            ) || isBusy
          "
          @click="
            sendReview();
            isBusy = true;
          "
          >ارسال داوری</b-button
        >
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../main"; // REVIEW

export default {
  name: "Reviewing",
  props: ["disabled", "scoresData", "refereeIdea", "refereeDecision"],
  components: {},

  data() {
    return {
      isBusy: false,
      refereeDecision2: this.refereeDecision,
      refereeIdea2: this.refereeIdea,
      score: [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
      weight: [4, 4, 10, 10, 4, 8, 8, 8, 4, 6, 8, 10, 8, 4, 4],

      refereeDecisions: [
        { value: null, text: "لطفا نظر خود را انتخاب کنید", disabled: true },
        { value: "accept", text: "مورد تایید است" },
        {
          value: "minorRevision",
          text: "با اصلاحات بدون نیاز به داوری مجدد مورد تایید است",
        },
        {
          value: "majorRevision",
          text: "نیازمند اصلاحات و داوری مجدد",
        },
        { value: "reject", text: "مورد تایید نیست" },
      ],
    };
  },

  computed: {
    totalScore() {
      // NOTE (c-totalScore) to show the proposal total score
      let totalScore = 0;
      for (let i = 0; i < 15; i++) {
        totalScore += this.score[i] * this.weight[i];
      }
      return totalScore / 4;
    },
  },
  methods: {
    sendReview() {
      // NOTE (m-sendReview) to send review
      this.$http
        .post(
          this.baseUrl + "/setad/reviewer/review/project/done",
          {
            reviewId: this.$route.params.judgeId,
            description: this.refereeIdea2,
            decision: this.refereeDecision2,
            scores: this.score,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            EventBus.$emit("refereeAdded", {});
            this.$router.replace("/referee/archive");
          } else if (res.status == 202) {
            this.toast(res.data.text, "success");
            this.toast(res.data.error, "error");
            this.$router.replace("/referee/archive");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });

      this.fileBusy = false;
    },
  },
  mounted() {
    // NOTE (MOUNTED) to show data of proposal score
    if (this.scoresData) this.score = this.scoresData;
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
